module.exports = __webpack_public_path__ + "static/media/variable.ca16cc04.svg";